import { NavLink, Outlet } from 'react-router-dom';
import { Logo } from '../../componentes/Marca.tsx';
import { BotaoTema } from '../../componentes/Tema.tsx';
import { Botao, Icone } from '../../componentes/ui/index.ts';
import { useSessao } from '../../lib/sessao.tsx';
import { ROTULO_PAPEL } from '../../lib/tipos.ts';

/**
 * A navegação é montada a partir do papel. Isso é conveniência de UI, não
 * segurança: quem digitar a URL de uma tela de admin sendo `financeiro` leva
 * 403 do backend, que é onde a regra realmente vive.
 */
export function LayoutPainel() {
  const { usuario, sair } = useSessao();
  const admin = usuario?.papel === 'admin';

  const links = [
    ...(admin
      ? [
          { para: '/painel', rotulo: 'Visão geral', icone: <Icone.Casa tamanho={16} />, fim: true },
          { para: '/painel/inscricoes', rotulo: 'Inscrições', icone: <Icone.Ficha tamanho={16} /> },
          { para: '/painel/houses', rotulo: 'Quartos', icone: <Icone.Casa tamanho={16} /> },
        ]
      : []),
    { para: '/painel/financeiro', rotulo: 'Financeiro', icone: <Icone.Dinheiro tamanho={16} /> },
    ...(admin
      ? [
          { para: '/painel/usuarios', rotulo: 'Acessos', icone: <Icone.Usuario tamanho={16} /> },
          {
            para: '/painel/config',
            rotulo: 'Configurações',
            icone: <Icone.Engrenagem tamanho={16} />,
          },
        ]
      : []),
  ];

  return (
    <div style={{ minHeight: '100dvh', display: 'flex', flexDirection: 'column' }}>
      <header
        className="cartao--vidro"
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 20,
          borderBottom: '1px solid var(--borda)',
          borderRadius: 0,
        }}
      >
        <div
          className="container linha linha-entre"
          style={{ paddingBlock: 'var(--gap-3)', gap: 'var(--gap-4)', flexWrap: 'nowrap' }}
        >
          <div className="linha" style={{ gap: 'var(--gap-3)', flexWrap: 'nowrap' }}>
            <Logo tamanho={32} />
            <span
              style={{
                fontFamily: 'var(--fonte-display)',
                fontWeight: 700,
                letterSpacing: '-0.02em',
              }}
            >
              Painel
            </span>
          </div>

          <div className="linha" style={{ gap: 'var(--gap-2)', flexWrap: 'nowrap' }}>
            <div
              style={{ textAlign: 'right', lineHeight: 1.25, minWidth: 0 }}
              className="usuario-topo"
            >
              <div
                style={{
                  fontSize: 'var(--texto-sm)',
                  fontWeight: 600,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {usuario?.nome}
              </div>
              <div className="texto-fraco" style={{ fontSize: 'var(--texto-xs)' }}>
                {usuario?.papel ? ROTULO_PAPEL[usuario.papel] : '—'}
              </div>
            </div>
            <BotaoTema />
            <Botao
              variante="fantasma"
              onClick={() => void sair()}
              icone={<Icone.Sair />}
              aria-label="Sair do painel"
              title="Sair"
            />
          </div>
        </div>

        <nav className="container" aria-label="Seções do painel">
          <div
            className="linha"
            style={{ gap: 'var(--gap-1)', overflowX: 'auto', flexWrap: 'nowrap' }}
          >
            {links.map((l) => (
              <NavLink
                key={l.para}
                to={l.para}
                end={l.fim}
                className="painel-link"
                style={({ isActive }) => ({
                  display: 'flex',
                  alignItems: 'center',
                  gap: 'var(--gap-2)',
                  padding: '0.65rem 0.85rem',
                  fontSize: 'var(--texto-sm)',
                  fontWeight: 600,
                  textDecoration: 'none',
                  whiteSpace: 'nowrap',
                  color: isActive ? 'var(--laranja-texto)' : 'var(--texto-suave)',
                  borderBottom: `2px solid ${isActive ? 'var(--laranja)' : 'transparent'}`,
                  transition: 'color var(--rapido), border-color var(--rapido)',
                })}
              >
                {l.icone}
                {l.rotulo}
              </NavLink>
            ))}
          </div>
        </nav>
      </header>

      <main id="conteudo" className="container" style={{ paddingBlock: 'var(--gap-6)', flex: 1 }}>
        <Outlet />
      </main>
    </div>
  );
}
